import { CustomerLightData } from './customer-light.data';
import { PartnerLightData } from './partner-light-data';
import { FeatureFlag } from './feature-flag';

export type CustomerConfigurableFeatureFlags = Extract<FeatureFlag, FeatureFlag.IDENTECO | FeatureFlag.BREACH_LENSE>;

export interface Customer extends CustomerLightData {
  id: number;
  companyName: string;
  configured: boolean;
  horizonApiKey?: string;
  numberOfLicencedHosts: number;
  betaFeaturesEnabled: boolean;
  features: Record<CustomerConfigurableFeatureFlags, boolean>;
  partner?: PartnerLightData;
  hasEncryptionConfig: boolean;
}

export const DEMO_CUSTOMER: Customer = {
  id: -1,
  companyName: 'Demo Customer',
  configured: true,
  numberOfLicencedHosts: 100,
  betaFeaturesEnabled: false,
  features: {
    [FeatureFlag.BREACH_LENSE]: true,
    [FeatureFlag.IDENTECO]: false,
  },
  hasEncryptionConfig: false,
};
